import { rgb2hsv } from "./color-conversions";
const colorsys = require("colorsys");

export const convertHexToHsv = (hex: string) => {
  const rgb = colorsys.hexToRgb(hex);
  const hsv = rgb2hsv(rgb.r, rgb.g, rgb.b);
  return hsv;
};
